import React from "react";

export function KpiTile({ label, value, delta, suffix, valueClassName = "", testId }) {
  const deltaNum = typeof delta === "number" ? delta : null;
  const deltaPositive = deltaNum !== null && deltaNum >= 0;

  return (
    <div
      className="card-surface p-4 flex flex-col gap-2 min-h-[120px]"
      data-testid={testId}
    >
      <div className="overline">{label}</div>
      <div className={`font-mono text-3xl sm:text-4xl tracking-tight text-zinc-900 ${valueClassName}`}>
        {value}
        {suffix && <span className="text-lg text-muted-foreground ml-1">{suffix}</span>}
      </div>
      {deltaNum !== null && (
        <div
          className={`text-xs font-mono ${deltaPositive ? "text-emerald-700" : "text-rose-700"}`}
        >
          {deltaPositive ? "↑" : "↓"} {Math.abs(deltaNum).toFixed(1)}% vs prior
        </div>
      )}
    </div>
  );
}
